

import { Component, Vue } from 'vue-property-decorator';
import {image} from '../../../../public/images/ministryJusticeLogo'

@Component
export default class ParentingAfterSeparation extends Vue {
image = image
}
